export const CHANGE_LOCAL = 'LANGUAGE/CHANGE_LOCAL';
